
<span>
  <span v-if="isBlank" class="text-black-50">--</span>
  <slot v-else></slot>
</span>
